import React from 'react';

// MARQIT ANALYTICS — full two-line logo
// MARQIT: original vector paths (black + teal accent on Q)
// ANALYTICS: same width as MARQIT, teal, letter-spaced
// The logo keeps its own original teal: the interface teal of the theme is a different shade.

export const LOGO_TEAL = '#08BBB5';

// The teal Q of the logo, with its tail: the sign of the collapsed sidebar.
const Q_PATH = 'M323.267 49.4779C314.115 49.4779 306.702 42.0259 306.702 32.8254C306.702 23.6248 314.115 16.1732 323.267 16.1732H363.975C373.126 16.1732 380.541 23.6309 380.541 32.8254C380.541 36.029 379.404 39.1517 379.404 39.1517C379.141 39.8272 377.847 43.0594 374.581 45.9742C372.69 47.6595 370.824 48.6347 369.549 49.1891C372.295 50.0548 375.223 51.1053 378.283 52.3867C382.561 54.1761 386.363 56.1097 389.677 58.0086C389.85 57.8585 400.322 49.945 401.368 32.8306C401.368 14.7007 386.741 -0.000976562 368.704 -0.000976562H318.537C300.5 -0.000976562 285.875 14.7004 285.875 32.8306C285.875 50.9609 300.5 65.6622 318.537 65.6622L347.533 65.593C353.66 65.7254 357.796 66.3663 361.592 68.2942C366.656 70.8625 379.603 86.2221 379.603 86.2221L392.707 69.3792C392.707 69.3792 381.973 61.512 372.718 55.5933C366.42 51.5656 359.1 49.4358 351.629 49.4444L323.267 49.4772L323.267 49.4779Z';

export const MarqitLogoMark = ({ width = 36 }) => (
  <svg width={width} height={Math.round((width * 87) / 116)} viewBox="285.5 -0.5 116.5 87" fill="none" aria-hidden="true">
    <path d={Q_PATH} fill={LOGO_TEAL} />
  </svg>
);

const MarqitLogoFull = ({ width = 180 }) => {
  const viewW = 508;
  const viewH = 120;
  const h = Math.round(width * viewH / viewW);

  return (
    <svg
      width={width}
      height={h}
      viewBox={`0 0 ${viewW} ${viewH}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* ── MARQIT ── */}
      <path d="M20.5284 30.0494V61.9111H0V0.929199H24.6913L56.6752 45.3277L88.6538 0.929199H113.345V61.9054H92.8167V29.9569L69.3142 61.9054H43.9509L20.5288 30.0438V30.0555L20.5284 30.0494Z" fill="#141414"/>
      <path d="M413.497 0H433.942L420.96 61.3283H400.431L413.497 0Z" fill="#141414"/>
      <path d="M439.526 0H508V16.9181H481.788V61.3283H461.844V16.9237H435.545L439.526 0Z" fill="#141414"/>
      <path d="M209.808 62.2746H188.51L166.472 18.3142H159.69L137.652 62.2746H116.44L147.666 0.958008H178.668L209.814 62.275H209.808V62.2746Z" fill="#141414"/>
      <path d="M213.954 0.958008H259.891C275.355 0.958008 283.05 7.32462 283.05 19.6133C283.05 28.0059 278.818 33.5237 271.198 35.983C278.422 36.4911 282.975 40.9818 282.975 48.4507V61.8538H264.52V51.6833C264.52 46.2633 263.113 44.6472 258.083 44.6472H232.404V61.8538H213.949V0.958008H213.96H213.955H213.954ZM255.487 28.6871C260.431 28.6871 263.813 27.6712 263.813 22.7477C263.813 17.8242 260.443 16.9005 255.487 16.9005H232.404V28.6871H255.487Z" fill="#141414"/>
      <path d={Q_PATH} fill={LOGO_TEAL}/>

      {/* ── ANALYTICS — same width as MARQIT (textLength stretches spacing) ── */}
      <text
        x="0"
        y="114"
        textLength="508"
        lengthAdjust="spacing"
        fontFamily="Inter, Arial, sans-serif"
        fontWeight="700"
        fontSize="26"
        fill={LOGO_TEAL}
      >ANALYTICS</text>
    </svg>
  );
};

export default MarqitLogoFull;
